<div class="settings settings-delete" [ngClass]="{'settings-open': isOpen }">
    <button class="settings__trigger" (click)="openSettings()">
        <span class="sr-only">{{'words.delete' | translate}}</span>
    </button>
    <div class="settings__content">
        <div class="settings-block">
            <div class="settings-block__text">
                <div class="settings-block__title">
                    <h5>{{ message | translate }}</h5>
                </div>
                <p class="settings-block__hint">{{ 'words.delete-confirm-hint' | translate }}</p>
            </div>
            <div class="settings-block_details">
                <button class="cancel" (click)="closeSettings()">
                    <span>{{'words.cancel' | translate}}</span>
                </button>
                <button class="delete" (click)="onDeleteContent()">
                    <span>{{'words.yes-delete' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
